import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const TitleWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: 0.75rem; // 12px to rem
  span {
    flex: 1;
  }

  .font-weight-strong {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }
`;

export const ModalBody = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalText = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-size: clamp(0.875rem, 2vw, 1rem);
  font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
  line-height: ${({ theme: { token } }) => token.lineHeight};
`;
